module.exports = __webpack_public_path__ + "media/audio116.b4bf5ee3.mp3";